module.exports = __webpack_public_path__ + "static/media/truck.7f71ce1a.jpg";